(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["neo-bs5-carousel"] && !Shopify.designMode) return;
  try {
    
	(function() {
	  document.addEventListener('DOMContentLoaded', function() {
		var sliders = document.querySelectorAll('.neo-bs5-carousel-slick');
  
		if (typeof jQuery === 'undefined') return;
  
		sliders.forEach(function(slider) {
		  var $slider = jQuery(slider);
		  if (typeof $slider.slick !== 'function') return;
  
		  var autoplaySpeedAttr = slider.getAttribute('data-autoplay-speed');
		  var autoplaySpeed = parseInt(autoplaySpeedAttr, 10);
		  if (isNaN(autoplaySpeed)) autoplaySpeed = 5000;
  
		  $slider.slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			arrows: true,
			prevArrow: '<button type="button" class="slick-prev neo-bs5-carousel-prev" aria-label="Previous"><span>&lt;</span></button>',
			nextArrow: '<button type="button" class="slick-next neo-bs5-carousel-next" aria-label="Next"><span>&gt;</span></button>',
			autoplay: true,
			autoplaySpeed: autoplaySpeed,
			responsive: [
			  {
				breakpoint: 768,
				settings: {
				  slidesToShow: 1,
				  slidesToScroll: 1
				}
			  }
			]
		  });
		});
	  });
	})();
  
  } catch(e) { console.error(e); }
})();
})();
